import { Injectable } from '@angular/core';
import { CanActivate} from '@angular/router';
import { TokenService } from './token.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BeforeLoginService implements CanActivate{

  canActivate(): boolean {   
  
    return !this.Token.loggedIn();    
  }
  constructor(
    private Token:TokenService,
    private router :Router,
    ) { }
}
